import React from 'react';
import './InstallPWAButton.css';

interface InstallPWAButtonProps {
  onInstall: () => void;
  isInstallable: boolean;
  isInstalled: boolean;
}

const InstallPWAButton: React.FC<InstallPWAButtonProps> = ({ 
  onInstall, 
  isInstallable, 
  isInstalled 
}) => {
  if (isInstalled || !isInstallable) {
    return null;
  }

  return (
    <div></div>
    // <button className="install-pwa-btn" onClick={onInstall}>
    //   <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    //     <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
    //   </svg>
    //   {/* <span>Cài đặt App</span> */}
    // </button>
  );
};

export default InstallPWAButton;
